"use client";

import React, { JSX } from "react";
import { AppPlaceholder } from "@sitecore-content-sdk/nextjs";
import componentMap from ".sitecore/component-map.client";
import {
  SplitterParams,
  SplitterProps,
} from "components/sxa/column-splitter/column-splitter.props";

const COLUMN_INDEXES = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export const Default = ({
  params,
  rendering,
  page,
}: SplitterProps): JSX.Element => {
  const enabledPlaceholders = (params?.EnabledPlaceholders ?? "")
    .split(",")
    .filter(Boolean);
  const id = params?.RenderingIdentifier;

  const columnWidths = COLUMN_INDEXES.map(
    (i) =>
      params?.[`ColumnWidth${i}` as keyof SplitterParams] as string | undefined,
  );
  const columnStyles = COLUMN_INDEXES.map(
    (i) => params?.[`Styles${i}` as keyof SplitterParams] as string | undefined,
  );

  const paddingPageBuilder = page?.mode?.isEditing ? "p-5" : "p-0";
  const containerClasses = `column-splitter-component flex flex-wrap mx-auto ${
    params?.GridParameters ?? ""
  } ${params?.Styles ?? ""} ${paddingPageBuilder}`.trim();

  return (
    <div
      className={containerClasses}
      id={id || undefined}
      data-role="column-splitter-component"
    >
      {enabledPlaceholders.map((ph, index) => {
        const phKey = `column-${ph}-{*}`;
        const colIdx = Number(ph) - 1;
        const phStyles = `shrink-0 min-w-0 wrap-anywhere ${
          columnWidths[colIdx] || ""
        } ${columnStyles[colIdx] || ""}`.trim();

        return (
          <div key={`col-${colIdx}-${index}`} className={phStyles}>
            <div className="w-full">
              <AppPlaceholder
                name={phKey}
                rendering={rendering}
                page={page}
                componentMap={componentMap}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
